"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Breadcrumbs = void 0;
const react_1 = __importStar(require("react"));
const box_1 = require("../box");
const link_1 = require("../link");
const text_1 = require("../text");
const styles_1 = require("./styles");
const Breadcrumbs = (props) => {
    const { breadcrumbs, styles, separator = '›' } = props;
    const lastIndex = breadcrumbs.length - 1;
    const isLastItem = (index) => index >= lastIndex;
    return (react_1.default.createElement(box_1.Box, { container: true, direction: 'row' }, breadcrumbs.map((breadcrumb, index) => (react_1.default.createElement(react_1.Fragment, { key: index },
        react_1.default.createElement(box_1.Box, { item: true },
            react_1.default.createElement(link_1.Link, { href: breadcrumb.url, color: styles === null || styles === void 0 ? void 0 : styles.color, colorHover: styles === null || styles === void 0 ? void 0 : styles.hover },
                react_1.default.createElement(text_1.Text, null, breadcrumb.name))),
        !isLastItem(index) && (react_1.default.createElement(box_1.Box, { item: true },
            react_1.default.createElement(styles_1.Separator, null, separator))))))));
};
exports.Breadcrumbs = Breadcrumbs;
